import AutomationProgressBar from "../command/AutomationProgressBar.jsx";
import SnapshotPicker from "./SnapshotPicker.jsx";

/** Persistent assessment controls — visible on every workspace tab. */
export default function WorkspaceCommandBar({
  snapshots = [],
  selectedSnapshotId = null,
  onSelectSnapshot = null,
  onRunNewAssessment = null,
  snapshotsBusy = false,
  snapshotsError = "",
  assessmentProgressSteps = null,
  statusLabel = "Ready",
  statusBusy = false,
}) {
  return (
    <div
      className="shrink-0 border-b px-4 py-2"
      style={{ borderColor: "var(--border)", background: "var(--bg-surface)" }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
        <SnapshotPicker
          snapshots={snapshots}
          selectedSnapshotId={selectedSnapshotId}
          onSelectSnapshot={onSelectSnapshot}
          busy={snapshotsBusy}
        />
        <button
          type="button"
          onClick={() => onRunNewAssessment?.()}
          disabled={snapshotsBusy}
          className="rounded border border-white/10 bg-white/[0.04] px-2 py-1 text-[11px] font-medium text-slate-200 hover:bg-white/[0.08] disabled:opacity-40"
        >
          Run new assessment
        </button>
        {statusBusy ? (
          <span className="text-accent flex items-center gap-2 text-xs">
            <span
              className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-[var(--border-bright)] border-t-[var(--accent)]"
              aria-hidden
            />
            {statusLabel}
          </span>
        ) : (
          <span className="text-dim text-xs">{statusLabel}</span>
        )}
        {snapshotsError ? (
          <span className="text-dim" style={{ fontSize: "11px" }}>
            {snapshotsError}
          </span>
        ) : null}
      </div>
      {snapshotsBusy && Array.isArray(assessmentProgressSteps) && assessmentProgressSteps.length > 0 ? (
        <div style={{ marginTop: "8px" }}>
          <AutomationProgressBar steps={assessmentProgressSteps} />
        </div>
      ) : null}
    </div>
  );
}
